import React from "react";
import { useGlobalContext } from "./context/globalContext";

const AboutDeveloper = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/logo.png"
          height="65px"
          loading="lazy"
          alt="Raymond's MIG Bandra"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h2 className="d-block section-heading-sub text-capitalize">
            About Developer
          </h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={() => handleShowModal("AboutDev ChatWithUs")}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        Raymond Realty is part of the esteemed Raymond Group, which has a rich
        legacy spanning over 95 years. The group’s reputation for quality
        craftsmanship and ethical business practices instills trust and
        confidence among investors. Raymond Realty is known for its commitment
        to superior quality and innovative design. Each project reflects
        meticulous attention to detail, architectural finesse, and the use of
        cutting-edge technologies, ensuring enduring value for investors.
      </p>

      <button
        className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("AboutDev ChatWithUs")}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
